import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';

export const registerService = async (name, email, password, religion) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/register`, {name, email, password, religion})
        .then((response)=>{
            console.log(response)
            return response?.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

export const loginService = async (email, password) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/login`, {email, password})
        .then((response)=>{
            return response.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

export const logoutService = async (access_key) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/logout`, {access_key})
        .then((response)=>{
            return response.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

export const updateRegisterPlaceService = async (access_key, register_place) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/update_register_place`, {access_key, register_place})
        .then((response)=>{
            return response.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

export const recoverPasswordService = async (title, text, button_text, email) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/recover_password`, {title, text, button_text, email})
        .then((response)=>{
            return response.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

export const resetPasswordService = async (code, password) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/reset_password`, {code, password})
        .then((response)=>{
            return response.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}

export const validateResetPasswordService = async (code) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/user/validate_reset_password`, {code})
        .then((response)=>{
            return response.data
        }).catch((error)=>{
            console.log(error)
            return error.response.data.message || 'generic_server_error_message'
        })
    } catch (error) {
        toast.error('A server error ocurred.')
    }
}


